function collapseSpace(value) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim();
}

function leadDisplayName(lead) {
  if (!lead) return '';
  const named = collapseSpace(lead.name);
  if (named) return named;
  const person = collapseSpace([lead.first_name, lead.last_name].filter(Boolean).join(' '));
  if (person) return person;
  return collapseSpace(lead.company_name);
}

/**
 * Heading shown in place of a free-text project title.
 * Example: "Sebastian Zijp - PRJ-2026-280"
 */
export function projectDisplayTitle(project) {
  if (!project) return '';
  const name = leadDisplayName(project.lead);
  const number = collapseSpace(project.project_number);
  if (name && number) return `${name} - ${number}`;
  if (name) return name;
  const stored = collapseSpace(project.title);
  if (stored) return stored;
  return number;
}
